import { render, staticRenderFns } from "./CampaignStatusManagement.vue?vue&type=template&id=27f8c383&scoped=true&"
import script from "./CampaignStatusManagement.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatusManagement.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignStatusManagement.vue?vue&type=style&index=0&id=27f8c383&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8c383",
  null
  
)

export default component.exports